import { Box } from '../../Box';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { resolveInputFontSize } from '../../TextInput/TextInputStyles';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const resolvePadding = size => {
  const padding = {
    small: '8px',
    sm: '8px',
    medium: '12px',
    md: '12px',
    large: '16px',
    lg: '16px'
  };
  return padding[size || 'medium'];
};
const resolveStyle = (size, theme) => {
  const style = {
    display: 'flex',
    minHeight: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1 0 0',
    padding: `${resolvePadding(size)} 0`,
    alignSelf: 'stretch',
    overflow: 'hidden',
    color: theme.tokens.SemColorOnSurfaceDefault,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: theme.tokens.SemTypeFontBody,
    fontSize: resolveInputFontSize(theme, size),
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '100%'
  };
  return style;
};
export const ReadOnlySingle = props => {
  const {
    size,
    selectedOptions,
    id,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const style = resolveStyle(size, theme);
  const value = selectedOptions[0] ? selectedOptions[0].label : '\u2014';
  return /*#__PURE__*/_jsx(Box, {
    className: 'ids-comboBox-read-only-single',
    sx: style,
    id: idBuilder('ids-comboBox-read-only-single', id),
    "data-testid": idBuilder('ids-comboBox-read-only-single', rest['data-testid']),
    children: value
  });
};